import React, { useEffect, useState } from "react";
import { Table, Image, Button } from "react-bootstrap";
import BasicPagination from "../../../../Pagination/Pagination";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";


export const ReelsPageComponent = (props) => {
    const [page, setPage] = useState(1);
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(10);

    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const toggleTrDetail = (index) => {
        setSelectedRowIndex(selectedRowIndex === index ? null : index);
    };


    const handleBatchChange = (pageNo) => {
        window.scrollTo(0, 0);
        var calcStart = pageNo * 10 - 10;
        setStart(calcStart);
        setEnd(pageNo * 10);
        setPage(pageNo);
    };
    let filteredData = props.data;

    return (
        <React.Fragment>
            <>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
                    <Table className="enMinWidth900">
                        <thead>
                            <tr className="super_admin_all_users_table_head">
                                <th style={{ width: "20%" }} className="f12-700">
                                    Uploaded by
                                    <br />
                                    /Role/ID
                                </th>
                                <th style={{ width: "20%" }} className="f12-700">
                                    Reel/
                                    <br />
                                    ID
                                </th>
                                <th style={{ width: "20%" }} className="f12-700">
                                    Tapped
                                </th>
                                <th style={{ width: "20%" }} className="f12-700">
                                    Viewed
                                </th>
                                <th style={{ width: "20%" }} className="f12-700">
                                    Ordered/Booked
                                </th>

                            </tr>
                        </thead>
                        {filteredData.map((item, index) => (
                            <tbody className="HideShowTable" onClick={() => toggleTrDetail(index)}
                                key={index}
                            >
                                <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">

                                    <td style={{ width: "15%" }}>
                                        <div className="mt-2 f12-500">{item.uploadedBy}</div>
                                    </td>
                                    <td style={{ width: "25%" }}>
                                        <div className="d-flex align-items-center">
                                            <div className="text-center d-flex flex-column align-items-center">
                                                <div className="enImage45">
                                                    <Image src={item.thumbnailUrl}
                                                    />
                                                </div>
                                                <div className="text-break">
                                                            <div className="f14-500 mt-2" style={{ color: "#2196F3" }}>
                                                                {item._id}
                                                            </div>   
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{ width: "20%" }}>
                                        <div className="f14-500">
                                            {item?.viewed ? "Yes" : "No"} 
                                        </div>
                                    </td>
                                    <td style={{ width: "20%" }}>
                                        <div className="f14-500">
                                            {" "}
                                            {/* {item?.viewedData?.views || item?.uploadedUser?.views > 0 ? "Yes" : "No"} */}
                                            {item?.views > 0 ? "Yes" : "No"}
                                        </div>
                                        <div className="f14-500">
                                            {" "}
                                            {moment(item.createdAt).format("LL")}
                                        </div>
                                        <div className="f14-500">
                                            {moment(item.createdAt).format("LT")}
                                        </div>
                                    </td>
                                    <td style={{ width: "20%" }}>
                                        <div className="f14-500">
                                            {" "}
                                          {item?.ordered ? "Yes" : "No"} 
                                        </div>
                                        <div className="f14-500">
                                            {" "}
                                            {/* {moment(item.createdAt).format("LL")} */}
                                        </div>
                                        <div className="f14-500">
                                            {/* {moment(item.createdAt).format("LT")} */}
                                        </div>
                                    </td>
                                </tr>
                                {selectedRowIndex === index && (
                                    <>
                                        <tr className="sd_accordion_body border-top" style={{ background: "#ffffff" }}>
                                            <td style={{ width: "20%" }}>
                                                <div className="mt-2" style={{ marginBottom: "5%" }}>Liked</div>
                                                <div className="f14-500 mt-2">
                                                    {item.likes  ? "YES" : "NO"}
                                                </div>
                                            </td>
                                            <td style={{ width: "20%" }}>
                                                <div className="mt-2" style={{ marginBottom: "5%" }}>Commented</div>
                                                <div className="f14-500 mt-2">{item.comments ? "Yes" : "No"} </div>
                                                <div>
                                                    <Button variant="link" className="f10-500 text-blue" style={{ padding: 0 }}
                                                    // onClick={handleSHowCount}
                                                    >View comments</Button></div>
                                            </td>
                                            <td style={{ width: "20%" }}>
                                                <div className="mt" style={{ marginBottom: "5%" }}>Number of Times
                                                    <br /> viewed
                                                </div>
                                                <div className="f12-400 mt-2">
                                                {item.viewedData && item.viewedData.count ? item.viewedData.count : "no views"}
                                                </div>
                                            </td>
                                            <td style={{ width: "20%" }}>
                                                <div className="mt-2" style={{ marginBottom: "5%" }}>View Reel Details</div>
                                                <Button
                                                    variant="link"
                                                    className="enIconBtn mr-3"
                                                // onClick={this.onOpenModal}
                                                >
                                                    <Image
                                                        src={require("../../../../../assets/images/UserManagement/eye.svg")}
                                                        alt="View"
                                                        title="View Details"
                                                        fluid
                                                    />
                                                </Button>
                                            </td>
                                        </tr>
                                    </>
                                )}

                            </tbody>
                        ))}
                    </Table>
                </div>
                <BasicPagination
                    //   totalRecords={}
                    limit={10}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                />
            </>
        </React.Fragment>
    )
}